import { Component } from '@angular/core';
import { FrontEndService } from "../../services/front-end.service";

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {
    sendState = "notFound";

    constructor(
        public frontEndService: FrontEndService,
    ) { }
}
